import { FC, PropsWithChildren } from "react";

import styled from "styled-components";

import { BaseProps } from "../../BaseProps";
import * as Color from "../../general/Color";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

/**
 * The TextColor component properties.
 */
export interface TextColorProps extends BaseProps {
  /**
   * The text color appearance. If not specified defaults to `dark grey 500`.
   */
  readonly appearance?: Color.RgbColor;
}

const StyledSpan = styled.span<{ appearance: Color.RgbColor }>`
  color: ${(props) => Color.toString(props.appearance)};
`;

/**
 * Displays text content with specified color.
 */
export const TextColor: FC<PropsWithChildren<TextColorProps>> = (props) => {
  const { children, appearance = Color.DarkGrey[500], style } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: ["textcolor"],
  });

  return (
    <StyledSpan appearance={appearance} {...baseHtmlProps} style={style}>
      {children}
    </StyledSpan>
  );
};
